module.exports = __webpack_public_path__ + "img/img_cs_phone_img4.f1fcd612.png";